/* istanbul ignore file */

export default {
  "privacy-policy": "https://www.vodafone.com.tr/gizlilik-ve-guvenlik-politikalari",
  "cookie-preferences": "https://www.vodafone.com.tr/gizlilik-ve-guvenlik-politikalari",
  "terms-and-conditions": "https://www.vodafone.com.tr/web-sitesi-kullanimi-hukum-ve-sartlari",
  "help-and-support": "https://www.vodafone.com.tr/yardim",
};
